export default __webpack_public_path__ + "static/media/logo.a0362261.png";